import React from "react";

const Support = () => {
    return (
        <div>
            <h1>Support</h1>
            <p>Welcome to the Support page.</p>
        </div>
    );
};

export default Support;